import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeBalanceForwardReport extends Layout {
    checkboxIncludeSettlement: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceOfficeBalanceForward: DataSource;
    textboxPayeeType: Textbox;
}
